import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import useFitText from "use-fit-text";
import axios from "../../services/axios";
import { convertLanguageToField } from "../../utils/functions";
import useAuth from "../../hooks/useAuth";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import KamaThemeCard from "../../components/kamasutra/themeCard";
import Spinner from "../../components/utils/spinner";

function HeaderCenter() {
  const { t } = useTranslation();
  const { fontSize, ref } = useFitText();

  return (
    <div className="flex flex-col items-center">
      <h1
        ref={ref}
        style={{ fontSize }}
        className="text-base leading-5 font-black"
      >
        {t("categoryKamasutra")}
      </h1>
    </div>
  );
}

export default function KamasutraThemes() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [themes, setThemes] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id_usuario) {
      axios
        .get(`/kamasutra/categories?id_usuario=${user?.id_usuario}`)
        .then((response) => {
          const titleField = convertLanguageToField(i18n.language, "title");
          const descriptionField = convertLanguageToField(
            i18n.language,
            "descr"
          );
          setThemes(
            response.data.map((theme) => {
              return {
                id_cat_kama: theme.id_cat_kama,
                title: theme[titleField],
                description: theme[descriptionField],
                acquired: theme.acquired,
                total: theme.total,
              };
            })
          );
        });
    }
  }, [user]);

  const handleClick = (theme) => {
    if (theme.acquired > 0) {
      navigate(`/kamasutra/game`, { state: { theme } });
    } else {
      navigate("/premium");
    }
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header HeaderLeft={BackHeaderLeft} HeaderCenter={HeaderCenter} />
      <NoHeaderScroll className="ps-5 pe-5">
        <div className="flex flex-col mt-5">
          {themes.length ? (
            themes.map((theme, index) => (
              <KamaThemeCard
                key={`theme-${theme.id_cat_kama}`}
                index={index}
                theme={theme}
                onClick={handleClick}
              />
            ))
          ) : (
            <div className="flex justify-center">
              <Spinner />
            </div>
          )}
        </div>
      </NoHeaderScroll>
    </div>
  );
}
